import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';
import { OnlineProduct } from '../../../../../../packages/apis/src/shopify/types/OnlineProduct';

type ShopifyProduct = {
  Display: {
    AverageProductReviewRating: number;
    NumberOfProductReviews: number;
  };
  ProductTags: {
    GoogleTagManager: {
      Brand: string;
      Category: string;
      Name: string;
      Price: number;
    };
    AllCalculatedProductTags?: Array<string>;
  };
  Family?: {
    StandAloneSkus?: Array<string>;
  };
  sku?: string;
  Id?: string;
  Price?: {
    SaveAmount: number;
    DisplayWasPrice: boolean;
  };
};

interface transformShopifyProductForTrackingProps {
  item: ShopifyProduct | OnlineProduct;
  isAvailable?: boolean;
  listName?: string;
  reviewCount?: number;
  reviewScore?: number;
}

export const transformShopifyProductForTracking = ({
  item,
  isAvailable,
  listName,
  reviewCount,
  reviewScore,
}: transformShopifyProductForTrackingProps): EcommerceCartItem | undefined => {
  const gtmProduct = item.ProductTags?.GoogleTagManager;

  const { Brand, Category, Name, Price } = gtmProduct;
  const categories = Category.split('/');

  let variant = '(unavailable)';
  if (item.Family && item.Family.StandAloneSkus) {
    const matchedVariant = item.Family.StandAloneSkus.find((sku: string) => sku === item.sku);
    if (matchedVariant) {
      variant = matchedVariant;
    }
  }

  return {
    discount: item.Price?.DisplayWasPrice ? item.Price?.SaveAmount : 0,
    item_bestseller_flag: item.ProductTags?.AllCalculatedProductTags?.join(', ') || '(none)',
    item_brand: Brand,
    item_category: categories[0],
    item_category2: categories[1],
    item_category3: categories[2],
    item_category4: categories[3],
    item_id: item.sku || item.Id || '(unavailable)',
    item_list_name: listName || '(unavailable)',
    item_name: Name,
    item_review_count: reviewCount ?? item.Display?.NumberOfProductReviews ?? '(unavailable)',
    item_review_score: reviewScore || item.Display?.AverageProductReviewRating || '(unavailable)',
    item_variant: variant,
    price: Price,
    quantity: 1,
    stock: isAvailable ? 'in stock' : isAvailable === false ? 'out of stock' : '(unavailable)',
  };
};
